<template>
    <div class="layout__position-relative layout__top-minus-30px layout__width-200px layout__float-right">
        <div class="layout__padding-clear">
			<div class="layout__position-center text__align-center text__line-height-2 layout__padding__bottom-20">
				<div class="component__footer__terms-and-conditions layout__position-right layout__padding__right-10px" v-show="version != 'manage-templates'">
					Directmailr version: {{version}}
				</div>
			</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "footer",
        data() {
            return {
                version: '',
                register: '',
                rules: {}
            }
        },
        mounted() {
            window.addEventListener('version-changed', (event) => {
                this.version = event.detail.storage;
            });
        },
        methods: {},
    };
</script>